import { useEffect, useState } from 'react';
import { breakpoints } from '../assets/styles/_breakpoints';

export const BREAKPOINT_XXS_INDEX = 0;
export const BREAKPOINT_XS_INDEX = 1;
export const BREAKPOINT_S_INDEX = 2;
export const BREAKPOINT_M_INDEX = 3;
export const BREAKPOINT_L_INDEX = 4;

const parseSize = (size) => Number(size.replace('px', ''));

const MEDIA_MATCHERS = (() => {
  let matchers = [];
  const breakpointEntries = Object.values(breakpoints).sort(
    (a, b) => parseSize(a.size) - parseSize(b.size)
  );

  for (let i = 0; i < breakpointEntries.length; i += 1) {
    const current = breakpointEntries[i];
    const next = breakpointEntries[i + 1];

    if (current && next) {
      const nextSize = Number(next.size.replace('px', '')) - 1;
      matchers.push(
        window.matchMedia(
          `(min-width: ${current.size}) and (max-width: ${nextSize}px)`
        )
      );
    } else {
      matchers.push(window.matchMedia(`(min-width: ${current.size})`));
    }
  }

  return matchers;
})();

// Returns current active breakpoint's index in ['xxs', 'xs', 's', 'm', 'l']
export const useMediaQuery = () => {
  const [matchingMedia, setMatchingMedia] = useState(
    MEDIA_MATCHERS.findIndex((matcher) => matcher.matches)
  );

  useEffect(() => {
    let listeners = [];
    MEDIA_MATCHERS.forEach((matcher, index) => {
      const listener = () => {
        if (matcher.matches) {
          setMatchingMedia(index);
        }
      };
      matcher.addEventListener('change', listener);
      listeners.push(listener);
    });

    return () => {
      listeners.forEach((listener, index) => {
        MEDIA_MATCHERS[index].removeEventListener('change', listener);
      });
    };
  }, []);

  return matchingMedia;
};

export const RESOLUTION_PHONE = 0;
export const RESOLUTION_TABLET = 1;
export const RESOLUTION_DESKTOP = 2;

const BREAKPOINT_TO_RESOLUTION_MAP = {
  [BREAKPOINT_XXS_INDEX]: RESOLUTION_PHONE,
  [BREAKPOINT_XS_INDEX]: RESOLUTION_TABLET,
  [BREAKPOINT_S_INDEX]: RESOLUTION_DESKTOP,
  [BREAKPOINT_M_INDEX]: RESOLUTION_DESKTOP,
  [BREAKPOINT_L_INDEX]: RESOLUTION_DESKTOP,
};

export const useResolution = () => {
  const breakpoint = useMediaQuery();
  return BREAKPOINT_TO_RESOLUTION_MAP[breakpoint];
};

const BREAKPOINT_TO_STYLE_MAP = {
  [BREAKPOINT_XXS_INDEX]: 'xxs',
  [BREAKPOINT_XS_INDEX]: 'xs',
  [BREAKPOINT_S_INDEX]: 's',
  [BREAKPOINT_M_INDEX]: 'm',
  [BREAKPOINT_L_INDEX]: 'l',
};

export const useBreakpointStyle = (styleClass) => {
  const breakpoint = useMediaQuery();
  return `${styleClass}--${BREAKPOINT_TO_STYLE_MAP[breakpoint]}`;
};
